import React from 'react';
import PropTypes from 'prop-types';

const RadioButton = ({ children, name, label, onChange, onClick, value, checked, disabled, labelClasses }) => {
  const uniqueIdentifier = `${value}-${name}`;

  // If the component has children, render them instead of the label
  let buttonText;
  if (children) {
    buttonText = children;
  } else {
    buttonText = label;
  }

  return (
    <div className="radio-btn">
      <input
        type="radio"
        id={uniqueIdentifier}
        name={name}
        value={value}
        onChange={onChange}
        onClick={onClick}
        checked={checked}
        disabled={disabled}
        className="radio-input-faux"
      />
      <label htmlFor={uniqueIdentifier} className={`btn btn--tertiary radio-btn__label ${labelClasses}`}>{buttonText}</label>
    </div>
  );
};

RadioButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]).isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  labelClasses: PropTypes.string,
};

export default RadioButton;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/RadioButton.js